<div class="grid place-items-center tk-grid-rows h-screen tk-bg-gray-1 tk-i-background">

  <div [formGroup]="form" class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">{{'set-new-password.header' | translate}}</div>

    <div *ngIf="showTokenError" id="token-invalid-error" class="mt-4 flex items-center tk-bg-error h-10 rounded">
      <span class="i-red-exclamation ml-2"></span>
      <span class="tk-c-red text-xs mx-2 opacity-100">{{'set-new-password.incorrect-link-error' | translate}}</span>
    </div>

    <div *ngIf="showTokenExpiredError" id="token-expired-error"
         class="mt-4  flex items-center tk-bg-error h-10 rounded">
      <span class="i-red-exclamation ml-2"></span>
      <span class="tk-c-red text-xs mx-2 opacity-100">{{'set-new-password.outdated-link-error' | translate}}</span>
    </div>

    <ng-container *ngIf="!showTokenError && !showTokenExpiredError">
      <div class="mt-4 tk-c-gray text-xs text-center">
        <div>{{'password-change-shared.password-requirements-part1' | translate}}</div>
        <div>{{'password-change-shared.password-requirements-part2' | translate}}</div>
      </div>

      <mat-form-field class="mt-5 mb-2" hideRequiredMarker>
        <mat-label>{{'password-change-shared.new-password' | translate}}</mat-label>
        <input matInput class="tk-password-spacing" [type]="inputType" formControlName="newPassword">

        <span matSuffix *ngIf="!isRawPasswordVisible && isVisibleShowPasswordButton"
              class="tk-c-blue text-xs tracking-widest" (click)="onShowPasswords()">
          {{ 'labels.show' | translate | uppercase }}
        </span>

        <span matSuffix *ngIf="isRawPasswordVisible && isVisibleShowPasswordButton"
              class="tk-c-blue text-xs tracking-widest" (click)="onHidePasswords()">
          {{ 'labels.hide' | translate | uppercase }}
        </span>

        <mat-error *ngIf="newPasswordCtrl.invalid" id="{{getErrorMessageElementId('newPassword', newPasswordCtrl)}}">
          {{getEmailErrorMessage(newPasswordCtrl)}}</mat-error>
      </mat-form-field>

      <mat-form-field class="mt-2 mb-2" hideRequiredMarker>
        <mat-label>{{'password-change-shared.repeat-new-password' | translate}}</mat-label>
        <input matInput class="tk-password-spacing" [type]="inputType" formControlName="newPasswordRepeat">
        <mat-error *ngIf="newPasswordRepeatCtrl.invalid"
                   id="{{getErrorMessageElementId('newPasswordRepeat', newPasswordRepeatCtrl)}}">
          {{getEmailErrorMessage(newPasswordRepeatCtrl)}}</mat-error>
      </mat-form-field>

      <app-button [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine"
                  innerTextClasses="my-1.5" spinnerClasses="my-3" label="{{'labels.save' | translate | titlecase}}"
                  (click)="onSave()"></app-button>

    </ng-container>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>
